import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';

import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import {
  Criterium,
  CriteriumTable,
  CriteriumSkeleton,
  CriteriumIconAndText,
  CriteriumOpenGraphPreview
} from '@hydra/common/criterium';
import StructuredDataIssueText from '@hydra/common/components/StructuredDataIssueText';
import { useReviewContext } from '@hydra/common/context';

const REQUIRED_PROPERTIES = ['og:type', 'og:image', 'og:url', 'og:title', 'og:description'];
const PREVIEWER_PROPERTIES = ['og:url', 'og:title', 'og:description'];

const useStyles = makeStyles({
  whiteSpaceColumn: {
    whiteSpace: 'normal'
  }
});

export const OpenGraph = ({ criterium }) => {
  const classes = useStyles();
  const { data } = criterium;
  const { variant } = useReviewContext();

  const properties = data.properties || [];
  const issues = data.issues || [];
  const storedImage = data.storedImage;
  const sortProperties = (properties) => {
    const sortedProperties = [];
    REQUIRED_PROPERTIES.forEach(prop => {
      const currentProperty = properties.find(({ property }) => property === prop);
      if (currentProperty) {
        sortedProperties.push(currentProperty);
      }
    });

    properties
      .slice()
      .sort((aProperty, bProperty) => {
        if (aProperty.property < bProperty.property) {
          return -1;
        }
        if (aProperty.property > bProperty.property) {
          return 1;
        }
        return 0;
      })
      .forEach((currentProperty) => {
        if (!includes(REQUIRED_PROPERTIES, currentProperty.property)) {
          sortedProperties.push(currentProperty);
        }
      });

    return sortedProperties;
  };

  const createTableRow = ({ property, value }) => {
    return [
      property,
      <span className={classes.whiteSpaceColumn} key='value'>{value}</span>];
  };
  const rows = sortProperties(properties).map(createTableRow);
  const head = [<Translate content='open_graph_tag' component='span' key='open_graph_tag' />, ''];

  const content = (
    <>
      {
        isEmpty(properties)
          ? (variant === 'nocrit' ? <CriteriumSkeleton width='30%' /> : <Translate content='open_graph_ko' />)
          : (
            <>
              {
                issues
                  .filter(({ meta }) => !PREVIEWER_PROPERTIES.includes(meta.property))
                  .map((issue, i) => (
                    <CriteriumIconAndText
                      key={i}
                      success={false}
                      text={<StructuredDataIssueText issue={issue} />}
                    />
                  ))
              }
              <CriteriumOpenGraphPreview properties={properties} issues={issues} storedImage={storedImage} />
              <CriteriumTable head={head} rows={rows} fixedColumns={[2, 8]} striped nowrap />
            </>
            )
      }
    </>
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

OpenGraph.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      properties: PropTypes.arrayOf(
        PropTypes.object
      ),
      issues: PropTypes.arrayOf(
        PropTypes.object
      ),
      storedImage: PropTypes.object
    })
  })
};

export default React.memo(OpenGraph);
